import type { ShallowRef } from 'vue'

import { shallowRef } from 'vue'

export type AccountStoreRecord<T> = Record<string, Record<string, T>>

export interface AccountStoreMapOptions<T> {
  getKey?: (record: T) => string
  getAccountId?: (record: T) => number
}

export function useAccountStoreMap<T extends { id?: number }>(
  identityStore: { accountId: number },
  options?: AccountStoreMapOptions<T>,
) {
  const map: ShallowRef<AccountStoreRecord<T>> = shallowRef({})
  const { getKey, getAccountId } = options ?? {}

  function updateMap(updatedRecords: T[]): void {
    const updatedAccountMap = updatedRecords.reduce<AccountStoreRecord<T>>(
      (accumulator, updatedRecord) => {
        const accountId = getAccountId ? getAccountId(updatedRecord) : identityStore.accountId
        let accountRecords = accumulator[accountId]
        if (!accountRecords) {
          accountRecords = {}
        }
        accountRecords[getKey ? getKey(updatedRecord) : `${updatedRecord.id ?? 0}`] = updatedRecord
        accumulator[accountId] = accountRecords
        return accumulator
      },
      {},
    )
    map.value = {
      ...map.value,
      ...updatedAccountMap,
    }
  }

  return { map, updateMap }
}
